import { render } from "./ModalCreateEditSample.vue?vue&type=template&id=efc37cd6&scoped=true&ts=true"
import script from "./ModalCreateEditSample.vue?vue&type=script&lang=ts"
export * from "./ModalCreateEditSample.vue?vue&type=script&lang=ts"

import "./ModalCreateEditSample.vue?vue&type=style&index=0&id=efc37cd6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc37cd6"]])

export default __exports__